export enum ApplicationType {
  PANEL = "panel",
  OVERLAY = "overlay",
}

export interface AppRootState {
  version: string;
  applicationType: ApplicationType;
}
